import { LockableTextArea } from '@components/Card2/LockableTextArea';
import { useCardPopoverInputFocus } from '@hooks/card';

import LinkStatusContainer from '../LinkStatusContainer/LinkStatusContainer';

interface PropertyFormFieldProps {
  value: string | null;
  label: string;
  onChange: (field: string) => void;
  toggleLocked?: (locked: boolean) => void;
  locked: boolean;
  linked?: boolean;
}

export const PropertyFormField: React.FC<React.PropsWithChildren<PropertyFormFieldProps>> = ({
  value,
  label,
  onChange,
  toggleLocked,
  linked = false,
  locked,
}) => {
  const onFocus = (inputNode: HTMLInputElement) => {
    inputNode.setSelectionRange(inputNode.value.length, inputNode.value.length);
  };
  const { inputRef } = useCardPopoverInputFocus({ onFocus });

  return (
    <LinkStatusContainer linked={linked}>
      <LockableTextArea
        label={label}
        value={value ?? ''}
        locked={locked}
        onChange={(event) => onChange(event.currentTarget.value)}
        toggleLocked={toggleLocked ? () => toggleLocked(!locked) : undefined}
        // @ts-expect-error - TODO - fix text area ref type error
        ref={inputRef}
        rows={3}
        required
      />
    </LinkStatusContainer>
  );
};
